import { render, staticRenderFns } from "./QuestionRectSingle.vue?vue&type=template&id=4894bce4&scoped=true&"
import script from "./QuestionRectSingle.vue?vue&type=script&lang=js&"
export * from "./QuestionRectSingle.vue?vue&type=script&lang=js&"
import style0 from "./QuestionRectSingle.vue?vue&type=style&index=0&id=4894bce4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4894bce4",
  null
  
)

export default component.exports